import { useState } from "react";
import axios from "axios";

function useAddMatch() {
  const [loading, setLoading] = useState(false);

  const addMatch = async (matchData) => {
    try {
      setLoading(true);
      const BEARER_TOKEN = "Bearer " + window.localStorage.getItem("jwt");
      const ADD_MATCH_URL = process.env.REACT_APP_URL_API + "/matchs";
      const matchResponse = await axios.post(ADD_MATCH_URL, matchData, {
        headers: { Authorization: BEARER_TOKEN }
      });
      console.log(matchResponse?.data);
      return matchResponse?.data?.message;
    } catch (e) {
      console.log(e?.response?.data?.message);
      return e?.response?.data?.message;
    } finally {
      setLoading(false);
    }
  };

  return { loading, addMatch };
}

export default useAddMatch;
